import "@modules/util/LiveCharacterCounter"
import "@modules/util/failed-image-detector"

import "@modules/bookmarks/tags/tag-list"
import { renderEntryRatings } from "@modules/bookmarks/entries/entry-ratings"

import "@modules/bookmarks/bookmarks-pc.css"
import { updateMerkzettelStateInMenu } from "@modules/bookmarks/bookmarks-menu-item.ts"
import { initializeCards } from "@modules/bookmarks/entries/entry-cards"
import { lookForBookmarksThatCanBeMerged, memoryModalNotShowAgain } from "@modules/bookmarks/entries/merge-cookie.ts"
import { addEventListenersForSideBarOptions } from "@modules/bookmarks/entries/sideBarOptions.ts"
import {
    hideAdProviderWhenTagIsSelected,
    showEmptyTagHitsContainerWhenAppliedTagHasNoEntries,
} from "@modules/bookmarks/tags/Tag.ts"
import { addListenersToMailButton } from "@modules/favourite-bookmarks/favourite-bookmarks.ts"

const moreButtonsList = document.querySelectorAll<HTMLElement>(".entry-more-data")
const recalculateContactBoxHeight = (moreButton: HTMLElement): void => {
    const contactBox = moreButton
        .closest("article")
        ?.querySelector<HTMLElement>(".entry-card--contact-box") as HTMLElement | null
    const contentHeightPx: number = contactBox?.querySelector("div")?.scrollHeight ?? 0

    contactBox?.style.setProperty("--open-container-height", contentHeightPx + "px")
}

const mediaChangeCallbacks: Array<() => void> = []

for (const moreButton of moreButtonsList) {
    moreButton?.addEventListener("click", (): void => {
        const contactBox = moreButton
            .closest("article")
            ?.querySelector<HTMLElement>(".entry-card--contact-box") as HTMLElement | null

        recalculateContactBoxHeight(moreButton)

        moreButton.classList.toggle("active")
        contactBox?.classList.toggle("open")

        const moreButtonLabel = moreButton.querySelector("span")

        if (!moreButtonLabel) {
            return
        }

        if (moreButton.classList.contains("active")) {
            moreButtonLabel.textContent = moreButtonLabel.dataset.active ?? ""
        } else {
            moreButtonLabel.textContent = moreButtonLabel.dataset.default ?? ""
        }
    })

    mediaChangeCallbacks.push((): void => recalculateContactBoxHeight(moreButton))
}

const callMediaChangeCallbacks = (): void => {
    for (const callback of mediaChangeCallbacks) {
        callback()
    }
}

matchMedia("(max-width: 1199px)").addEventListener("change", (): void => callMediaChangeCallbacks())
matchMedia("(max-width: 991px)").addEventListener("change", (): void => callMediaChangeCallbacks())

initializeCards()
addListenersToMailButton()
renderEntryRatings()
lookForBookmarksThatCanBeMerged()
memoryModalNotShowAgain()
updateMerkzettelStateInMenu(true)
addEventListenersForSideBarOptions()
hideAdProviderWhenTagIsSelected()
showEmptyTagHitsContainerWhenAppliedTagHasNoEntries()
